function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.617188 25 C 49.617188 38.59375 38.59375 49.617188 25 49.617188 C 11.40625 49.617188 0.382812 38.59375 0.382812 25 C 0.382812 11.40625 11.40625 0.382812 25 0.382812 C 38.59375 0.382812 49.617188 11.40625 49.617188 25 Z M 49.617188 25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,3.921569%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 32.6875 33.492188 L 17.3125 33.492188 C 15.304688 33.492188 13.671875 31.859375 13.671875 29.855469 L 13.671875 20.144531 C 13.671875 18.140625 15.304688 16.507812 17.3125 16.507812 L 32.6875 16.507812 C 34.695312 16.507812 36.328125 18.140625 36.328125 20.144531 L 36.328125 29.855469 C 36.328125 31.859375 34.695312 33.492188 32.6875 33.492188 Z M 17.3125 17.570312 C 15.890625 17.570312 14.738281 18.726562 14.738281 20.144531 L 14.738281 29.855469 C 14.738281 31.273438 15.890625 32.429688 17.3125 32.429688 L 32.6875 32.429688 C 34.109375 32.429688 35.261719 31.273438 35.261719 29.855469 L 35.261719 20.144531 C 35.261719 18.726562 34.109375 17.570312 32.6875 17.570312 Z M 17.3125 17.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,3.921569%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 16.453125 20.195312 C 19.171875 22.847656 21.890625 25.496094 24.613281 28.144531 C 25.117188 28.640625 25.894531 27.863281 25.386719 27.371094 C 22.667969 24.71875 19.949219 22.070312 17.230469 19.417969 C 16.722656 18.925781 15.945312 19.703125 16.453125 20.195312 Z M 16.453125 20.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,3.921569%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 25.386719 28.144531 C 28.109375 25.496094 30.828125 22.847656 33.546875 20.195312 C 34.054688 19.703125 33.277344 18.925781 32.769531 19.417969 C 30.050781 22.070312 27.332031 24.71875 24.613281 27.371094 C 24.105469 27.863281 24.882812 28.640625 25.386719 28.144531 Z M 25.386719 28.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,3.921569%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 33.515625 30.023438 C 31.707031 28.304688 29.898438 26.589844 28.089844 24.875 C 27.574219 24.386719 26.796875 25.164062 27.3125 25.652344 C 29.121094 27.367188 30.929688 29.082031 32.738281 30.800781 C 33.253906 31.285156 34.03125 30.511719 33.515625 30.023438 Z M 33.515625 30.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,3.921569%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 17.308594 30.800781 C 19.117188 29.082031 20.929688 27.367188 22.738281 25.652344 C 23.253906 25.164062 22.472656 24.386719 21.960938 24.875 C 20.152344 26.589844 18.339844 28.304688 16.53125 30.023438 C 16.015625 30.511719 16.796875 31.285156 17.308594 30.800781 Z M 17.308594 30.800781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedEmail);
export default __webpack_public_path__ + "static/media/roundedEmail.d9fe41ea9066dc365c7f2db15ce79a73.svg";
export { ForwardRef as ReactComponent };